import React, { useState } from 'react';

import { useToast } from 'Component/Alerta';
import Botao from 'Component/Botao';
import Imagem from 'Component/Imagem';
import Quiz from 'Interface/Quizzes';
import { useRemoverQuizMutation } from 'View/Service/Default/Quizzes';

import Editar from './Editar';

interface Props {
  dados: Quiz;
  acoes?: boolean;
}

const Lista = ({ dados }: Props): React.ReactElement => {
  const toast = useToast();
  const [modal, setModal] = useState<boolean>(false);
  const [removerQuiz] = useRemoverQuizMutation();

  const remover = async (): Promise<void> => {
    try {
      await removerQuiz(dados).unwrap();

      toast({
        conteudo: 'Removido com sucesso!',
        tema: 'success',
      });
    } catch (erro) {
      toast({
        titulo: 'Erro ao remover',
        conteudo: 'Verifique o registro de log para mais detalhes!',
        tema: 'danger',
      });
    }
  };

  return (
    <div className="border-bottom">
      <div className="py-2 px-3 d-flex">
        <div className="cursor-pointer" onClick={() => setModal(true)}>
          <p className="white-space-pre-wrap">{dados.enunciado}</p>
        </div>
        <div className="ms-auto">
          <Botao
            icone="trash"
            tema="danger"
            className="ms-5 align-self-end"
            confirmacao="Você tem certeza que deseja remover esse quiz? Essa ação é irreversivel."
            onClick={remover}
          />
        </div>
      </div>
      {dados.imagem && (
        <div className="d-flex justify-content-center">
          <Imagem
            src={dados.imagem}
            className="img-fluid mx-3 mb-3 col-md-6 rounded-3 shadow-sm"
          />
        </div>
      )}
      <div className="p-3">
        <strong>Alternativas:</strong>
        <ol className="mb-0" type="A">
          {dados.alternativas?.map((alternativa) => (
            <li
              key={`${alternativa.id}-${alternativa.modificado}`}
              className={`white-space-pre-wrap ${
                alternativa.correta ? 'text-success fw-bold' : ''
              }`}
            >
              {alternativa.texto}
            </li>
          ))}
        </ol>
      </div>
      <Editar id={dados.id} exibir={modal} aoFechar={setModal} />
    </div>
  );
};

export default Lista;
